export default __webpack_public_path__ + "static/media/cancer_En.933e0015.webp";